import { observable, action, runInAction } from 'mobx'
import { json } from '../../../../utils/ajax'

class TechnicalBAtricle {

  @observable loading
  @observable content
  @observable articleId

  constructor (){
    this.loading = false;
    this.content = {}
    this.articleId = ''
  }

  @action
  initArticle = async(id) =>{
    runInAction(()=> {
      this.loading = true;
      this.articleId = id;
      this.content = {};
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent?id=`+id)
    if(res && res.status === 0){
      return
    }
    runInAction(()=>{
      this.content = res;
      this.loading = false;
    })
  }

}

export default new TechnicalBAtricle()


// WEBPACK FOOTER //
// ./src/project/dongfeng/technicalBriefing/TBArticle/store.js